export const extractIndex = (stringId: string) => {
  const match = stringId.match(/\d+/);
  console.log({ match });
  return match ? parseInt(match[0]) : null;
};
